import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Kampanie',
  filters: {
    search: 'Szukaj kampanii...',
  },
  columns: {
    title: 'Tytuł',
    created_by: 'Utworzone przez',
    schedule_mode: 'Tryb harmonogramu',
    scheduled_at: 'Zaplanowano na',
    sent_at: 'Wysłano o',
    status: 'Status',
    sent: 'Wysłano',
    delivered: 'Dostarczone',
    delivered_rate: 'Wskaźnik dostarczeń',
    clicks: 'Kliknięcia',
    click_rate: 'Wskaźnik kliknięć',
    live: 'Na żywo',
    actions: 'Akcje',
  },
  active_status: {
    draft: 'Szkic',
    active: 'Aktywna',
  },
  delivery: {
    in_progress: 'Oczekuje na potwierdzenie',
    awaiting: 'Oczekuje na potwierdzenie',
    verified: 'Zweryfikowano {{relative}}',
    next_check_around: 'Następne sprawdzenie ok. {{time}}',
  },
  breakdown: {
    delivered: '{{count}} dostarczonych',
    pending: '{{count}} oczekuje na potwierdzenie',
    failed_title: 'Niedostarczone',
    all_delivered: 'Dostarczone do wszystkich odbiorców.',
    load_error: 'Nie udało się załadować szczegółów dostarczenia.',
    reasons: {
      DeviceNotRegistered: 'Aplikacja usunięta lub powiadomienia wyłączone (wygasły token)',
      MessageRateExceeded: 'Tymczasowo ograniczone przez Expo',
      MessageTooBig: 'Zawartość powiadomienia jest zbyt duża',
      MismatchSenderId: 'Niezgodność danych uwierzytelniających push',
      InvalidCredentials: 'Nieprawidłowe dane uwierzytelniające push',
      batch_failed: 'Wysyłanie partii nie powiodło się',
      missing_ticket: 'Brak potwierdzenia od Expo',
      unknown: 'Nieznany błąd dostarczenia',
    },
  },
  created_by: {
    [CreatedBy.System]: 'System',
    [CreatedBy.User]: 'Użytkownik',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Natychmiastowy',
    [ScheduleMode.Scheduled]: 'Zaplanowana',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Wysyłanie',
    [DeliveryStatus.Sent]: 'Wysłano',
    [DeliveryStatus.Queued]: 'W kolejce',
    [DeliveryStatus.Failed]: 'Błąd',
  },
  actions: {
    details: 'Szczegóły',
    view_details: 'Zobacz szczegóły',
    resend: 'Wyślij ponownie',
    duplicate_edit: 'Duplikuj i edytuj',
    delete: 'Usuń',
    edit: 'Edytuj',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
  },
  success_messages: {
    campaign_updated: 'Kampania zaktualizowana pomyślnie',
    campaign_deleted: 'Kampania usunięta pomyślnie',
  },
  error_messages: {
    failed_to_update_campaign: 'Nie udało się zaktualizować kampanii',
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_delete_campaign: 'Nie udało się usunąć kampanii',
  },
};
